import { SIGNIN, SIGNUP } from 'marketing-website/constants/urls';
import WorkshopKit from 'marketing-website/media/images/pages/resources/workshop-nav@2x.jpg';

const navLinks = [
  {
    id: 0,
    isHeaderLight: false,
    title: 'Features',
    firstColumnHeading: 'core features',
    secondColumnHeading: 'more',
    size: 'm',
    type: 'dropdown',
    url: '/why-marvel',
    firstColumnItems: [
      {
        title: 'Prototyping',
        description: 'Create interactive mockups',
        url: '/features/prototyping',
      },
      {
        title: 'User Testing',
        description: 'Validate designs at speed',
        url: '/user-testing',
      },
      {
        title: 'Developer Handoff',
        description: 'Automatic design specs',
        url: '/features/handoff',
      },
      {
        title: 'Integrations',
        description: 'Power up for your workflow',
        url: '/features/integrations',
      },
    ],
    secondColumnItems: [
      {
        description: 'Wireframing',
        url: '/features/wireframing',
      },
      {
        description: 'Design',
        url: '/features/design',
      },
      {
        description: 'Collaboration',
        url: '/features/collaboration',
      },
      {
        description: 'Ballpark - User research for teams',
        url:
          'https://ballparkhq.com/?utm_campaign=Ballpark%20Launch%200422&utm_source=Marvel%20website&utm_medium=website-nav-dropdown',
      },
      {
        description: 'Marvel for Sketch',
        url: '/sketch',
      },
    ],
    footer: {
      description: 'Take platform tour',
      url: '/why-marvel',
    },
  },
  {
    id: 1,
    isHeaderLight: false,
    title: 'Examples',
    url: '/examples',
  },
  {
    id: 2,
    image: {
      src: WorkshopKit,
      alt: 'Download our free Design Thinking Workshop Kit',
      url: '/workshops',
    },
    isHeaderLight: false,
    title: 'Blog and more',
    firstColumnHeading: 'Community',
    secondColumnHeading: 'Free resources',
    secondSubColumnHeading: 'Marvel university',
    size: 'm',
    type: 'dropdown',
    url: '/enterprise',
    firstColumnItems: [
      {
        title: 'Blog',
        description: 'Explore the best articles in design. Updated daily.',
        url: 'https://blog.marvelapp.com/',
      },
      {
        title: 'Case Studies',
        description:
          'Find out how our customers have become more productive with Marvel',
        url: '/customer-stories',
      },
    ],
    secondColumnItems: [
      {
        description: 'eBooks',
        url: 'https://marvelapp.com/resources#bits+bobs',
      },
      {
        description: 'Webinars',
        url: 'https://marvelapp.com/resources#webinars',
      },
      {
        description: 'Product Updates',
        url: 'https://marvelapp.com/resources#productupdates',
      },
    ],
    secondSubColumnItems: [
      {
        description: 'Overview of Marvel',
        url: '/university/course/overview-of-marvel',
      },
      {
        description: 'Prototyping basics',
        url: '/university/course/prototyping-basics',
      },
    ],
  },
  {
    id: 3,
    isHeaderLight: false,
    title: 'Enterprise',
    url: '/enterprise',
  },
  {
    id: 4,
    isHeaderLight: false,
    title: 'Pricing',
    url: '/pricing',
  },
  {
    id: 5,
    title: 'Sign in',
    url: SIGNIN,
  },
  {
    id: 6,
    title: 'Sign up free',
    type: 'button',
    url: SIGNUP,
  },
];

export default navLinks;



// WEBPACK FOOTER //
// ./src/configs/navLinks.js